import {
    IChecklist2ReportAttentionRequired,
    IChecklist2ReportChecklistSummary,
    IChecklist2ReportContainer,
    IChecklist2ReportData,
    IChecklist2ReportRecentActivity,
    IChecklistV2FilterAvailableItems,
} from './fi-checklist2-report';

export interface IChecklist2ReportViewData {
    availableItems: IChecklistV2FilterAvailableItems;
    reportsCount: number;
    auditMode: boolean;

    getHistorySummary(reportId: number): IChecklist2ReportChecklistSummary[];
    getRecentActivity(reportId: number): IChecklist2ReportRecentActivity[];

    setReportData(reportData: IChecklist2ReportData, reportId: number): void;
}

export class FiChecklist2ReportData implements IChecklist2ReportViewData {
    private _auditMode: boolean;
    private _availableItems: IChecklistV2FilterAvailableItems;

    private _reportData: { [reportParameterId: number]: IChecklist2ReportData };

    get availableItems() {
        return this._availableItems;
    }

    get auditMode() {
        return this._auditMode;
    }

    private _reportsCount: number;
    get reportsCount() {
        return this._reportsCount;
    }

    constructor() {}

    setReportContainerData(reportContainer: IChecklist2ReportContainer, auditMode: boolean) {
        this._availableItems = reportContainer.AvailableItems;
        this._reportsCount = reportContainer.ReportParameters.length;
        this._auditMode = auditMode;

        this._reportData = reportContainer.ReportData;
    }

    //# region data getters NEW

    getOpenChecklistsSummary(reportId: number): IChecklist2ReportChecklistSummary[] {
        return this._reportData[reportId].OpenChecklistsSummary;
    }

    getDeviationsSummary(reportId: number): IChecklist2ReportAttentionRequired[] {
        return this._reportData[reportId].DeviationsSummary;
    }

    getHistorySummary(reportId: number): IChecklist2ReportChecklistSummary[] {
        return this._reportData[reportId].HistorySummary;
    }

    getRecentActivity(reportId: number) {
        return this._reportData[reportId].RecentActivity;
    }

    setRecentActivity(recentActivity: IChecklist2ReportRecentActivity[], reportId: number) {
        this._reportData[reportId].RecentActivity = recentActivity;
    }

    getReportData(reportId: number): IChecklist2ReportData {
        return this._reportData[reportId];
    }

    setReportData(reportData: IChecklist2ReportData, reportId: number) {
        this._reportData[reportId] = reportData;
    }

    deleteReportData(reportId: number) {
        delete this._reportData[reportId];
    }

    //# endregion
}
